<template>
  <span>
    <v-btn :loading="loading" @click="onClickUploadButton" outline color="blue">
      <i class="fas fa-file-upload mr-2"></i>Import</v-btn
    >
    <input
      type="file"
      :key="`file__${keyupload}`"
      class="form-control-file pt-2"
      name="csvUploadCentralHr"
      :id="'csvUploadCentralHr'"
      data-vv-as="File"
      v-validate="'mimes:text/xlsx'"
      accept=".xlsx"
      @input="onFileChange($event)"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />
  </span>
</template>

<script>
import XLSX from 'xlsx'
export default {
  data() {
    return {
      keyupload: 0,
      loading: false,
    }
  },
  methods: {
    onClickUploadButton() {
      document.getElementById('csvUploadCentralHr').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array', cellDates: true })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          var jsonresult = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
          jsonresult = jsonresult.map((obj) => {
            var objdata = obj
            for (const [key, value] of Object.entries(objdata)) {
              if (typeof value.getMonth === 'function') {
                objdata[key] = moment(value).add(7, 'hours').format('DD-MM-YYYY')
              }
            }
            return objdata

            // if(typeof el[key].getMonth === 'function') {

            // } else {

            // }
          })
          result.push(vm.trimObj(jsonresult))
        }
        vm.$emit('onChange', result)
        vm.loading = false
        // vm.uploadExcel(result)
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      // console.log(obj)
      var result = Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/importxlsx.vue